export default __webpack_public_path__ + "static/step-three-51adfcc8c30b9263df0cec16216d0fc2.png";